import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, mergeMap, exhaustMap } from "rxjs/operators";
import { ValueConfPageService } from "../../services/value-conf-page.service";
import { ValueConfPageTypes } from './value-conf-page.actions';


@Injectable()
export class ValueConfPageEffects {

    loadValueConfPages = createEffect(() =>
        this.actions$.pipe(
            ofType(ValueConfPageTypes.InvokeValueConfPagesApiType),
            // mergeMap((action: any) => {
            exhaustMap((action: any) => {
                return this.valueConfPageService.loadValueConfPages(action.searchtext, action.docStereoTypeId, action.currentpage, action.pagesize, action.dbname)
                    .pipe(map((data) => ({ type: ValueConfPageTypes.RetrieveValueConfPagesListType, valueconfpages: data })));
            })));

    constructor(private actions$: Actions, private valueConfPageService: ValueConfPageService) { }
}